import { Component, OnInit, Input } from "@angular/core";
import {
  DataService,
  Dialog,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  BulkUpdatePackageReviewDocument,
  CheckBulkUpdatePackageReviewDocument,
  PackageReviewsQuery,
  BulkAddPackageReviewDocument,
  BulkDeletePackageReviewDocument,
} from "src/generated-gql/graphql";
import { FormBuilder, UntypedFormGroup } from "@angular/forms";
import { ProductVariantSelectorComponent } from "../update-sku-dialog/product-variant-selector/product-variant-selector.component";
import { take, combineLatest } from "rxjs";

@Component({
  //selector: "approve-inbound-dialog",f
  templateUrl: "./bulk-add-sku-dialog.component.html",
  standalone: true,
  imports: [SharedModule, ProductVariantSelectorComponent],
})
export class BulkAddSkuDialogComponent implements Dialog<boolean>, OnInit {
  resolveWith: (result?: boolean) => void;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder
  ) {}
  ngOnInit(): void {}

  @Input()
  items: PackageReviewsQuery["packageReviews"]["items"];

  currentVariant: any;

  newVariant: any;

  

  detailForm = this.formBuilder.group({
    quantity: [1],
  });
  addNewProductVariant(event: any) {
    if (!event) {
      this.newVariant = null;
      return;
    }
    this.dataService.product
      .getProductVariant(event.productVariantId)
      .single$.subscribe((res) => {
        if (res.productVariant) {
          this.newVariant = res.productVariant;
        }
      });
  }

  save() {

    const data = this.detailForm.value;

    this.dataService
      .mutate(BulkAddPackageReviewDocument, {
        input: {
          ids: this.items.map((i) => i.id),
          quantity: data.quantity ?? 1,
          newVariantId: this.newVariant.id,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.bulkAddPackageReview) {
          this.notificationService.success(
            `Bulk add ${res.bulkAddPackageReview.length} items sucessfully`
          );
          this.resolveWith(true);
        }
      });
  }

  del() {

    this.dataService
      .mutate(BulkDeletePackageReviewDocument, {
        input: {
          ids: this.items.map((i) => i.id),
          variantId: this.newVariant.id,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.bulkDeletePackageReview) {
          this.notificationService.success(
            `Bulk delete ${res.bulkDeletePackageReview.length} items successfully`
          );
          this.resolveWith(true);
        }
      });
  }

  cancel() {
    this.resolveWith(false);
  }
}
